import React from 'react'

export default function Footer() {
  return (
    <div>
      <footer id="footer">
                <div className="container">
                   
                       E-Commerce
                   

                    <p>
                        Built by | &nbsp;  Liza Pambhar                       
                    </p>
                </div>
            </footer>
    </div>
  )
}
